import { observer } from 'mobx-react-lite'
import { ComponentProps, FC, MouseEventHandler } from 'react'
import { useAuth } from '../../../hooks/useAuth'
import useFavorite from '../../../hooks/useFavorite'
import { userIsLoggedIn } from '../../core/Authentication'
import Button from '../../core/Button/Button'
import { HeartFilled, HeartOutlined } from '../../core/icons'
import { MediaTypesType } from '../../core/Utils'

type CircleFavoriteButtonProps = ComponentProps<typeof Button> & {
  arpMediaIndex: number
  mediaType: MediaTypesType
}
const CircleFavoriteButton: FC<CircleFavoriteButtonProps> = ({
  arpMediaIndex,
  mediaType,
  ...props
}) => {
  const { toggleFavorite, isFavorited } = useFavorite(arpMediaIndex, mediaType)
  const { user } = useAuth()
  const handleClick: MouseEventHandler<HTMLButtonElement> = (evt) => {
    evt.stopPropagation()
    if (!userIsLoggedIn(user)) return
    toggleFavorite()
  }
  return (
    <Button type={'outlined'} bigSquare rounded onClick={handleClick} {...props}>
      {isFavorited ? <HeartFilled /> : <HeartOutlined />}
    </Button>
  )
}

export default observer(CircleFavoriteButton)
